// ===========================================================
// Google Tag Manager - VTO
// ===========================================================
const dataLayerCoreVTO = (section) => {
  dataLayer.push({
    "event": "essai_virtuel", 
    "Section": section
  });
}
const gtm_ctaStartTryOn = () => {
  dataLayerCoreVTO("Start");
}
const gtm_ctaUseDesktopCamera = () => {
  dataLayerCoreVTO("Manual scan");
}
const gtm_ctaScanComeback = () => {
  dataLayerCoreVTO("Scan comeback");
}
const gtm_ctaSuccessCrossplatform = () => {
  dataLayerCoreVTO("Success crossplatform");
}
const gtm_ctaConnection = () => {
  dataLayerCoreVTO("Connection");
}
const gtm_ctaFailCrossplatform = () => {
  dataLayerCoreVTO("Error");
}
const gtm_ctaProcessEnding = () => {
  dataLayerCoreVTO("End");
}